var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 30,
    fill: "#FFF2F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 67,
    width: 65,
    height: 16,
    rx: 5,
    fill: "#7C68D9",
    transform: "rotate(-7 28 67)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 50,
    width: 60,
    height: 16,
    rx: 5,
    fill: "#B48BEA",
    transform: "rotate(5 31 50)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 56,
    height: 16,
    rx: 5,
    fill: "#826CE0",
    transform: "rotate(-4 34 34)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.f855f8bb6d0adac0ef8776270c59008e.svg";
export { ForwardRef as ReactComponent };